<h2 mat-dialog-title>{{ data.title | resolveTranslateAbleText }}</h2>
<div mat-dialog-content>
  <mat-form-field class="w-full">
    <mat-label>{{ data.inputLabelText | resolveTranslateAbleText }}</mat-label>
    <input matInput [formControl]="control" />
    <mat-error [control]="control" [overrideErrors]="data.overrideErrors" />
  </mat-form-field>
</div>
<div align="start" mat-dialog-actions>
  <button mat-stroked-button type="button" [mat-dialog-close]="null">
    {{ data.cancelButtonText ?? defaultCancelLabelTextKey | resolveTranslateAbleText }}
  </button>
  <button
    mat-flat-button
    type="button"
    [disabled]="loading() || (submitted && control.invalid)"
    (click)="onSubmit()"
  >
    {{ data.submitButtonText ?? defaultSubmitLabelTextKey | resolveTranslateAbleText }}
  </button>
</div>
